import React from 'react';
import Avatar from './Avatar';
import * as URL from 'utilities/URL';

class AvatarLinked extends React.Component {
  handleClick(e) {
    URL.transitionTo(`/m/profile/${e.data.userId}`);
  }

  render() {
    return <Avatar onAvatarClick={this.handleClick} {...this.props} />;
  }
}

export default AvatarLinked;
